// Visual tokens. The screens import these as `T`.
// Color values resolve through CSS variables so user themes can update globally.

export const T = {
  bg: 'var(--c-bg)',
  surface: 'var(--c-surface)',
  surface2: 'var(--c-surface-2)',
  line: 'var(--c-line)',
  line2: 'var(--c-line-2)',

  text: 'var(--c-text)',
  textDim: 'var(--c-text-dim)',
  textMute: 'var(--c-text-mute)',

  accent: 'var(--c-accent)',
  accent2: 'var(--c-accent-2)',
  accentInk: 'var(--c-accent-ink)',

  ok: 'var(--c-ok)',
  warn: 'var(--c-warn)',
  danger: 'var(--c-danger)',

  radiusSm: 10,
  radiusMd: 14,
  radiusLg: 18,
  radiusXl: 22,

  font: "'Geist', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  fontMono: "'Geist Mono', ui-monospace, 'SF Mono', Menlo, monospace",
} as const;

export type Theme = typeof T;

export const THEME_STORAGE_KEY = 'boostly.theme';

export type ThemeId = 'boostly' | 'aqua' | 'ruby' | 'light';

export const appThemes: Array<{
  id: ThemeId;
  label: string;
  swatches: readonly [string, string, string];
}> = [
  { id: 'boostly', label: 'Boostly', swatches: ['#0a0c0f', '#c6ff3d', '#7fe05a'] },
  { id: 'aqua', label: 'Aqua', swatches: ['#081012', '#46dcff', '#39e58c'] },
  { id: 'ruby', label: 'Ruby', swatches: ['#100b0f', '#ff4f8b', '#48e0c2'] },
  { id: 'light', label: 'Light', swatches: ['#f6f8fb', '#246bfe', '#10b981'] },
];

export function getStoredTheme(): ThemeId {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    return appThemes.some((theme) => theme.id === raw) ? raw as ThemeId : 'boostly';
  } catch {
    return 'boostly';
  }
}

export function applyTheme(theme: ThemeId) {
  document.documentElement.dataset.theme = theme;
  try { localStorage.setItem(THEME_STORAGE_KEY, theme); } catch {}
}

export function applyStoredTheme() {
  applyTheme(getStoredTheme());
}

export const card = {
  background: T.surface,
  border: `1px solid ${T.line}`,
  borderRadius: T.radiusLg,
} as const;

export const btnIcon = {
  width: 36,
  height: 36,
  borderRadius: T.radiusSm,
  background: T.surface,
  border: `1px solid ${T.line}`,
  color: T.text,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
} as const;
